import "./Footer.css"

import React from 'react'
import { FaFacebook, FaGithub, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa"
import { Link, NavLink } from "react-router-dom"

const Footer = () => {
    return (
        <footer className="footer">
            <div className="right">
                <a href="https://www.linkedin.com/in/jatin-rawat-4a15141a0/" target="_blank"><FaLinkedin size="30" style={{ color: "#fff" }} className="icons" ></FaLinkedin></a>
                <a href="https://github.com/Hawkeye2108" target="_blank"><FaGithub size="30" style={{ color: "#fff" }} className="icons"></FaGithub></a>
                <p>Contact : <a href="https://gmail.com" target="_blank">jatinrawat2108@gmail.com</a></p> 
            
            </div>
            <p>
                &#169;Copyright Reserved
            </p>
        </footer>
    )
}

export default Footer